import { AlertType, ComponentFactory, ComponentId, dom } from "@omegagrid/core";
import { Header, parseComponentId } from "./components";
import { Application } from "./container/application";
import { AppComponent } from "./component";
import { AppMenu } from "./components/menu";
import { Logo } from "./components/logo";

const createAlert = (text: string, type: AlertType) => {
	const div = dom.createElement<HTMLDivElement>('div');
	div.innerHTML = `<og-alert text="${text}" type="${type}" icon="exclamation-circle"></og-alert>`;
	return div;
};

export class CoreApplication extends Application {

	componentFactories = new Map<ComponentId, ComponentFactory>([
		['logo', (id: ComponentId) => dom.createElement<Logo>('rp-app-logo')],
		['topLeft', (id: ComponentId) => dom.createElement<Logo>('rp-app-customlogo')],
		['topRight', (id: ComponentId) => dom.createElement<AppMenu>('rp-app-menu')],
		['topCenter', (id: ComponentId) => dom.createElement<Header>('rp-app-header')],
		['empty', (id: ComponentId) => {
			const div = dom.createElement<HTMLDivElement>('div');
			div.style.padding = '5px';
			div.appendChild(createAlert('undefined component', 'warning'));
			return div;
		}]
	]);

	async createComponent(id: ComponentId) {
		const parsedId = parseComponentId(id);
		const factory = this.componentFactories.get(parsedId.id);
		return factory ? factory(parsedId.id) as AppComponent : null;
	}

}
